import { Routes, Route, useLocation } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AnimatePresence } from 'framer-motion';

// Pages import routes
import PageNotFound from '../pages/PageNotFound';
import LayoutPage from '../layouts/LayoutPage';

import { useEffect } from 'react';
import { LayoutAdmin } from '../layouts/LayoutAdmin';
import { Dashboard } from '../features/admin/pages/Dashboard';
import { DashboardArticle } from '../ui/admin/DashboardArticle';

import { LayoutLogin } from '../layouts/LayoutLogin';
import { LayoutActus } from '../features/actus/LayoutActus';
import { Users } from '../ui/admin/Users';

import { isMaintenance } from "../Variables";

/*** Page in the feature folder ***/
// Campaigns
import { Campaign } from '../features/campaign/pages/Campaign';
// devis
import Devis from "../features/devis/pages/Devis";
// auth
import { Login } from '../features/auth/pages/Login';
// actus
import { Create } from '../features/actus/pages/Create';
import { Edit } from '../features/actus/pages/Edit';
import Actus from '../features/actus/pages/Actus';

// All pages of app
import Home from "../pages/Home";
import { LoadingCustom } from '../ui/atoms/LoadingCustom';
import { ShowCampaign } from '../features/campaign/pages/ShowCampaign';
import { ShowActus } from '../features/actus/pages/ShowActus';

const About = lazy(() => import('../pages/About'));
const Music = lazy(() => import('../pages/Music'));
const Maintenance = lazy(() => import('../pages/Maintenance'));
const Lab = lazy(() => import('../pages/Studio'));
const Galeries = lazy(() => import('../pages/Galeries'));
const Mentions = lazy(() => import('../pages/Mentions'));


const AnimatedRoutes = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }, [location]);

    return (
        <AnimatePresence initial={false} mode="wait">
            <Suspense fallback={<LoadingCustom />}>
                <Routes location={location} key={location.pathname}>
                    
                        {isMaintenance ?
                            <Route path="*" element={<Maintenance/>}/>
                            :
                            <>
                                <Route element={<LayoutPage />}>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/labs" element={<Lab />} />
                                    <Route path="/musics" element={<Music />} />
                                    <Route path="/apropos" element={<About />} />

                                    <Route path="/campagnes" element={<Campaign />} />
                                    <Route path="/actus" element={<Actus />} />
                                </Route>

                                <Route path="/labs/galeries" element={<Galeries />} />

                                <Route path="/mk-admin/*" element={<LayoutAdmin />}>
                                    <Route index element={<Dashboard />} />
                                    <Route path="mes-articles" element={<DashboardArticle />} />
                                    <Route path="mes-articles/:slug" element={<Edit />} />
                                    <Route path="creer" element={<Create />} />
                                    <Route path="utilisateurs" element={<Users />} />
                                </Route>

                                <Route element={<LayoutActus />}>
                                    <Route path="/actus/:slug" element={<ShowActus />} />
                                    
                                   
                                    <Route path="/campagnes/:slug" element={<ShowCampaign />} />
                                    <Route path="/mentionslegales" element={<Mentions />} />
                                </Route>

                                <Route element={<LayoutLogin />}>
                                    <Route path="/mk-login" element={<Login />} />
                                    <Route path="/creerundevis" element={<Devis />} />
                                </Route>

                                <Route path="/*" element={<PageNotFound />} />
                            </>
                        }
                    
                </Routes>
            </Suspense>
        </AnimatePresence>
    );
};

export default AnimatedRoutes;
